import PropTypes from 'prop-types';
import { useInView } from 'react-intersection-observer';
import styled from 'styled-components';

import devices from '@/utilities/devices';

const TitleContainer = styled.h2`
  font-size: ${props => props.fontSize};
  color: ${props => props.white ? props.theme.color.white : props.theme.color.black};
  width: ${props => props.width};
  margin: 0 ${props => props.align === 'center' && 'auto'};
  text-align: ${props => props.align === 'center' && 'center'};
  padding: ${props => props.padding};
  em {
    font-style: normal;
    display: inline-block;
    :after {
      display: block;
      content: "";
      height: 4px;
      width: ${props => props.isVisible ? '100%' : '0%'};
      margin-top: -9px;
      background-color: ${props => {
			switch (props.underlineColor){
				case 'red':
					return props.theme.color.red;
				case 'blue':
					return props.theme.color.blue;
				case 'prune':
					return props.theme.color.prune;
				case 'beige':
					return props.theme.color.beige;
			}
		}};;
      transition: all 1s cubic-bezier(0.230, 1.000, 0.320, 1.000) .2s;
    }
  }

  @media screen and (${devices.mobile}) {
    font-size: 1.5em;
    width: 95%;
    margin: auto;
    padding: 1em 0em .5em;
    text-align: center;
  }
  @media screen and (${devices.minTablet}) and (${devices.maxTablet}) {
    font-size: 1.8em;
    width: 90%;
    margin: auto;
    padding: 2em .5em .5em;
    text-align: center;
  }

  @media screen and (${devices.minLaptop}) and (${devices.maxLaptop}) {
    font-size: 1.7em;
  }
`;

const Title = ({ className, children, fontSize, underlineColor, white, width, align, padding }) => {
	// used to animate onScroll
	const [ref, inView] = useInView({
		triggerOnce: true,
		rootMargin: '-300px 0px',
	});
	return (
		<TitleContainer
			className={className}
			fontSize={fontSize}
			underlineColor={underlineColor}
			white={white}
			width={width}
			align={align}
			padding={padding}
			ref={ref}
			isVisible={inView}
		>
			{children}
		</TitleContainer>
	);
};

Title.defaultProps = {
	fontSize: '1.8em',
};

Title.propTypes = {
	className: PropTypes.any,
	children: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
	fontSize: PropTypes.string,
	underlineColor: PropTypes.oneOf(['red', 'blue', 'prune', 'beige']),
	white: PropTypes.bool,
	width: PropTypes.string,
	align: PropTypes.string,
	padding: PropTypes.string,
};

export default Title;
